import { render, staticRenderFns } from "./DespatchOut.vue?vue&type=template&id=46d52c4d&scoped=true&"
import script from "./DespatchOut.vue?vue&type=script&lang=js&"
export * from "./DespatchOut.vue?vue&type=script&lang=js&"
import style0 from "./DespatchOut.vue?vue&type=style&index=0&id=46d52c4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d52c4d",
  null
  
)

export default component.exports